import React from "react";
import { Drawer, Box, Typography } from "@mui/material";
import { useSettingsDrawer } from "../contexts/SettingsDrawerContext";

const SettingsDrawer: React.FC = () => {
  const { open, closeDrawer } = useSettingsDrawer();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      PaperProps={{
        sx: { width: 400, bgcolor: "#181818", color: "#fff", p: 3 },
      }}
    >
      <Box>
        <Typography variant="h6" fontWeight={700} mb={2}>
          Settings & Filters
        </Typography>
        {/* Settings content placeholder */}
        <Typography variant="body2" color="#bbb">
          Settings and filter configuration will appear here.
        </Typography>
      </Box>
    </Drawer>
  );
};

export default SettingsDrawer;
